import {Metric, MetricAxis, MetricInfo, MetricInfoGroup, MetricParams} from '@store/@types/metric';
import {List} from 'immutable';

// Metrics which exists in both x and y axis
const COMMON_METRICS: Omit<MetricInfo, 'group'>[] = [
  {
    title: 'Calls / Day',
    value: new MetricParams({
      metric: Metric.CALL_PLACED,
    }),
  },
  {
    title: 'Call Duration / Day',
    value: new MetricParams({
      metric: Metric.CALL_TOTAL_DURATION,
    }),
  },
];

export const HORIZONTAL_METRICS: List<MetricInfo> = List([
  {
    title: 'Skill (combined score)',
    value: new MetricParams({
      metric: Metric.AGGREGATED_SKILL,
    }),
    group: MetricInfoGroup.SKILL,
  },
  ...COMMON_METRICS.map<MetricInfo>(el => ({
    ...el,
    group: MetricInfoGroup.SKILL,
  })),
  {
    title: 'Avg Call Duration',
    value: new MetricParams({
      metric: Metric.CALL_AVG_DURATION,
    }),
    group: MetricInfoGroup.SKILL,
  },
  {
    title: 'Avg Skill Improvement in Coaching Plans / Month',
    value: new MetricParams({
      metric: Metric.COACHING_PLAN_IMPROVEMENT,
      direction: 'any',
    }),
    group: MetricInfoGroup.SKILL,
  },
  {
    title: 'Avg Call Score (By Self) / Week',
    value: new MetricParams({
      metric: Metric.CALL_SCORING,
      direction: 'review',
    }),
    group: MetricInfoGroup.SKILL,
  },
  {
    title: 'Avg Call Score (By Others) / Week',
    value: new MetricParams({
      metric: Metric.CALL_SCORING,
      direction: 'any',
    }),
    group: MetricInfoGroup.SKILL,
  },
  {
    title: 'Avg Interchanges / Minute',
    value: new MetricParams({
      metric: Metric.INTERCHANGES,
    }),
    group: MetricInfoGroup.SKILL,
  },
  {
    title: 'Avg Listening Percentage',
    value: new MetricParams({
      metric: Metric.TALK_LISTEN,
    }),
    group: MetricInfoGroup.SKILL,
  },
]);

export const VERTICAL_METRICS: List<MetricInfo> = List([
  {
    title: 'Engagement (combined score)',
    value: new MetricParams({
      metric: Metric.ENGAGEMENT,
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  ...COMMON_METRICS.map<MetricInfo>(el => ({
    ...el,
    group: MetricInfoGroup.ENGAGEMENT,
  })),
  {
    title: 'Own Calls Listened To / Week',
    value: new MetricParams({
      metric: Metric.CALL_LISTENED_COUNT,
      direction: 'review',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: "Others' Calls Listened To / Week",
    value: new MetricParams({
      metric: Metric.CALL_LISTENED_COUNT,
      direction: 'coach',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: 'Comments Left (Own Calls) / Week',
    value: new MetricParams({
      metric: Metric.COMMENTED,
      direction: 'review',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: "Comments Left (Others' Calls)",
    value: new MetricParams({
      metric: Metric.COMMENTED,
      direction: 'coach',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: 'Calls Scored (Own Calls)',
    value: new MetricParams({
      metric: Metric.CALL_SCORED,
      direction: 'review',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: "Calls Scored (Other's Calls)",
    value: new MetricParams({
      metric: Metric.CALL_SCORED,
      direction: 'coach',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: 'Library Adds (Own Calls)',
    value: new MetricParams({
      metric: Metric.LIBRARY_ADDS,
      direction: 'review',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
  {
    title: "Library Adds (Others' Calls)",
    value: new MetricParams({
      metric: Metric.LIBRARY_ADDS,
      direction: 'coach',
    }),
    group: MetricInfoGroup.ENGAGEMENT,
  },
]);

export const SKILL_METRICS = [Metric.AGGREGATED_SKILL, Metric.CALL_SCORING_SKILLS];
export const WILL_METRICS = [Metric.ENGAGEMENT];

export const getIsCoachingZone = (metric: {
  [MetricAxis.HORIZONTAL]: MetricParams;
  [MetricAxis.VERTICAL]: MetricParams;
}) => {
  return (
    SKILL_METRICS.includes(metric[MetricAxis.HORIZONTAL].metric) &&
    WILL_METRICS.includes(metric[MetricAxis.VERTICAL].metric)
  );
};
